import CoolidgeCalvinEmbed from "../images/CoolidgeCalvinEmbed";
import Coolidge from "../Thumbs/Coolidge60.jpg";

const CoolidgeCalvin = {
    objectName: 'CoolidgeCalvin',
    firstName: 'Calvin',
    lastName: 'Coolidge',
    dates: '1872-1933',
    id: 'CC1872-1933',
    image: CoolidgeCalvinEmbed,
    thumbImg: Coolidge,
    quotes: [
    {
        tabHeading: 'Calvin Coolidge - 150th Anv. of Independence',
        metaDescription: `President Calvin Coolidge's speech on the 150th anniversary for the Declaration of Independence.`,
        keywords: ["TrueLibertyNorth", ],
        title: '150th Anniversary - Independence',
        from: 'From: ',
        date: 'July 5, 1926',
        id: 'CC150ADI1926',
        headTitle: `Calvin Coolidge - 150th Anv. of Independence`,
        headDescription: `Calvin Coolidge's presidential speech on the 150th anniversary for the Declaration of Independence`,
        content: [
                {bold: `July 5, 1926`},                  
                {normal: `In its main features the Declaration of Independence is a great spiritual document. It is a declaration not of material but of spiritual conceptions. 
            Equality, liberty, popular sovereignty, the rights of man - these are not elements which we can see and touch. They are ideals. They have their source and their 
            roots in the religious convictions. They belong to the unseen world. Unless the faith of the American people in these religious convictions is to endure, the 
            principles of our Declaration will perish. We cannot continue to enjoy the result if we neglect and abandon the cause. `},
              {normal: `We are too prone to overlook another conclusion. Governments do not make ideals, but ideals make governments. This is both historically and logically 
            true. Of course the government can help to sustain ideals and can create institutions through which they can be the better observed, but their source by their 
            very nature is in the people. The people have to bear their own responsibilities. There is no method by which that burden can be shifted to the government. It is 
            not the enactment, but the observance of laws, that creates the character of a nation. `},
              {normal: `No other theory is adequate to explain or comprehend the Declaration of Independence. It is the product of the spiritual insight of the people. We 
            live in an age of science and of abounding accumulation of material things. These did not create our Declaration. Our Declaration created them. The things of 
            the spirit come first. Unless we cling to that, all our material prosperity, overwhelming though it may appear, will turn to a barren scepter in our grasp. If 
            we are to maintain the great heritage which has been bequeathed to us, we must be like-minded as the fathers who created it. We must not sink into a pagan 
            materialism. We must cultivate the reverence which they had for the things that are holy. We must follow the spiritual and moral leadership which they showed. 
            We must keep replenished, that they may glow with a more compelling flame, the altar fires before which they worshiped.`}
        ],
        considerations: [
            {
                name: '',
                title: 'Thomas Jefferson',
                date: '',
                content: [`I predict future happiness for Americans if they can prevent the government from wasting the labors of the people under the pretense of taking 
            care of them.`]
            },
            {
                name: '',
                title: 'John Adams',
                date: '',
                content: [`You will never know how much it cost the present generation to preserve your freedom! I hope you will make a good use of it.`]
            }
        ]
    }    
]};

export default CoolidgeCalvin;